import React, { useState, useImperativeHandle } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import { Space } from "antd";
import { Button, TextField, Box, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import crudActions from "../../../../CRUD/redux/actions";
import { ListTable } from '../FeatureList/ListTable';
import { emptyValidation } from "../../../../../helpers/validation";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import CustomAlert from "../../../../Shared/components/CustomAlert";


const Feature = React.forwardRef((props, ref) => {
    const { moduleId, featureVisible,
        moduleName, onParentEdit,
        loadTasks, commonError, onRequestSort, sortBy, sortOrder,
        handleFeatureAddMore, details, roleManagement, loadMoreContent,
        loadMore, loadMoreTask } = props;
    const { createLoader, editLoader } = useSelector(state => state.crudReducer);
    const [errorName, setErrorName] = useState(false);
    const [errorLabels, setErrorLabels] = useState(false);
    const [featureId, setFeatureId] = useState('');
    const [view, setView] = useState(false);
    const [name, setName] = useState('');
    const [deleteModal, setDeleteModal] = useState(false);



    const dispatch = useDispatch();

    const [form, setForm] = useState({
        moduleId: parseInt(moduleId)
    });

    const classes = customStyles();


    useImperativeHandle(ref, () => ({
        handleOpen() {
            emptyStateInput();
            emptyState();
            setView(false);
        },
        onDeleteParent(data) {
            setDeleteModal(true);
            setFeatureId(data.id);
            setName(data?.featureName);
        }
    }));


    const handleClose = () => {
        onParentEdit(false);
        emptyStateInput();
        emptyState();
    };

    const changeHandler = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    };

    const createFeature = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Name', form.featureName);
        let emptyLabels = emptyValidation('UI Label', form.uiLabel);

        emptyState();
        if (emptyName.isValid && emptyLabels.isValid) {
            delete form.percentage;
            dispatch({
                type: featureId === '' ? crudActions.CREATE_DETAILS_START : crudActions.EDIT_DETAILS_START,
                url: 'features',
                title: 'Features',
                id: featureId,
                details: form
            });
        } else {
            if (emptyName.errors) {
                setErrorName(emptyName.errors);
            }
            if (emptyLabels.errors) {
                setErrorLabels(emptyLabels.errors);
            }
        }
    }



    const emptyStateInput = () => {
        setForm({
            moduleId: parseInt(moduleId)
        });
        setFeatureId('');
    };

    const emptyState = () => {
        setErrorName(false);
        setErrorLabels(false);
    };

    const onEdit = (data) => {
        onParentEdit(true);
        setView(false);
        setFeatureId(data.id);
        setForm({
            ...form,
            featureName: data.featureName,
            description: data.description,
            uiLabel: data.uiLabel,
        });
    }

    const onView = (data) => {
        onParentEdit(true);
        setView(true);
        setFeatureId(data.id);
        setForm({
            ...form,
            featureName: data.featureName,
            uiLabel: data.uiLabel,
            description: data.description,
        });
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setFeatureId(data.id);
        setName(data.featureName);
    };

    const handleAddMore = (e) => {
        createFeature(e);
        handleFeatureAddMore();
    }

    const handleDeleteModal = (value) => {
        setDeleteModal(value);
    }

    return (
        <React.Fragment>
            <ListTable
                onEdit={(data) => onEdit(data)}
                onView={(data) => onView(data)}
                onDelete={(data) => onDelete(data)}
                details={details}
                loadMore={loadMore}
                sortOrder={sortOrder}
                sortBy={sortBy}
                onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
                loadMoreContent={loadMoreContent}
                loadMoreTask={loadMoreTask}
                from={"Module List"}
                roleManagement={roleManagement}
            />
            <PrimaryDrawer
                anchor={'right'}
                open={featureVisible}
                variant={'temporary'}
                handleClose={() => handleClose()}
                title={`${featureId ? `${view ? 'View' : 'Edit'} ` : 'Add'} Feature`}
                width={'360px'}
                className={classes.closeBackGround}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"
                        onSubmit={(e) => createFeature(e)}>
                        <div className={classes.customFormFlex}>
                            {
                                commonError && <CustomAlert error={commonError} customClass={clsx(classes.uploadError, classes.margin10t)} />
                            }
                            <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Module</Typography>
                            <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{moduleName}</Typography>
                            {
                                view ? (
                                    <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Feature</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.featureName}</Typography>
                                    </>
                                ) : (
                                    <TextField autoComplete='one-time-code'
                                        label={["Feature ", <span key={"Feature"} className={classes.colorRedRequired}> *</span>]}
                                        variant={'standard'}
                                        className={clsx(classes.margin30t)}
                                        error={errorName ? true : false}
                                        helperText={errorName}
                                        name={"featureName"}
                                        value={form.featureName}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                                )
                            }
                            {
                                view ? <>
                                    <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>UI Label</Typography>
                                    <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.uiLabel}</Typography>
                                </> :
                                    <TextField autoComplete='one-time-code'
                                        label={["UI Labels ", <span key={"Name"} className={classes.colorRedRequired}> *</span>]}
                                        variant={'standard'}
                                        className={clsx(classes.margin30t)}
                                        error={errorLabels ? true : false}
                                        helperText={errorLabels}
                                        name={"uiLabel"}
                                        value={form.uiLabel}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColorCustom,
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                            }
                            {
                                view ? (
                                    <>
                                        <Typography variant={'subtitle1'} className={clsx(classes.margin30t, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13, classes.margin30t)}>Description</Typography>
                                        <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form.description}</Typography>
                                    </>
                                ) : (
                                    <TextField autoComplete='one-time-code'
                                        label='Description'
                                        variant={'outlined'}
                                        name={"description"}
                                        value={form.description}
                                        multiline={true}
                                        className={clsx(classes.margin30t, classes.customDescription)}
                                        rows={15}
                                        InputProps={{
                                            classes: {
                                                input: classes.textFieldColor,
                                            }
                                        }}
                                        InputLabelProps={{
                                            className: classes.textFieldLableColor,
                                        }}
                                        onChange={(e) => changeHandler(e)}
                                    />
                                )
                            }
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            {
                                !view &&
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}
                                    >
                                        {
                                            featureId ? 'Update & Close' : 'Save & Close'
                                        }
                                    </Button>
                                    {
                                        !featureId && <Button
                                            key="add"
                                            onClick={(e) => handleAddMore(e)}
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                        >
                                            Add more
                                        </Button>
                                    }

                                </Space>
                            }
                        </div>
                    </Box>
                }
            />
            <DeleteModal onClose={(v) => handleDeleteModal(v)} id={featureId} loadTasks={() => loadTasks()} name={name} url={'features'} title={'Feature'} visible={deleteModal} />
        </React.Fragment>
    );
});

export default Feature;